export const TOS = 'tos';
export const TOS_ID = 1;
export const PRIVACY = 'privacy';
export const PRIVACY_ID = 2;
export const DNS = 'ds';
export const DNS_ID = 3;
